import { escapeSpecialChars } from 'src/lib/regex';

export const BLOG_FACTS_TYPE = {
  first: 'first',
  web: 'web',
  resource: 'resource',
} as const;
export type BlogFactsType = (typeof BLOG_FACTS_TYPE)[keyof typeof BLOG_FACTS_TYPE];

export const BLOG_DRAFT_STATUS = {
  editing: 'editing',
  draft: 'draft',
  archived: 'archived',
} as const;
export type BlogDraftStatus = (typeof BLOG_DRAFT_STATUS)[keyof typeof BLOG_DRAFT_STATUS];

export const BLOG_SECTION_TEXT_STATUS = {
  empty: 'empty',
  draft: 'draft',
  completed: 'completed',
} as const;
export type BlogSectionTextStatus =
  (typeof BLOG_SECTION_TEXT_STATUS)[keyof typeof BLOG_SECTION_TEXT_STATUS];

const blogTranslations = [
  'blog', // English, Spanish, etc.
  'блог', // Russian, Bulgarian
  'blogg', // Swedish
  'blogi', // Finnish
  'مدونة', // Arabic
  'وبلاگ', // Persian
  'בלוג', // Hebrew
  'ब्लॉग', // Hindi
  'ব্লগ', // Bengali
  'μπλογκ', // Greek
  '博客', // Chinese
  'ブログ', // Japanese
  '블로그', // Korean
  'บล็อก', // Thai
];

export const containsBlog = (text: string): boolean => {
  // Create a simple regex to match anywhere in the text (case-insensitive)
  const blogPattern = new RegExp(blogTranslations.map(escapeSpecialChars).join('|'), 'i');

  return blogPattern.test(text);
};
